import { render, staticRenderFns } from "./RightLowerBarLiteOpenProject.vue?vue&type=template&id=856a8eca&scoped=true&"
import script from "./RightLowerBarLiteOpenProject.vue?vue&type=script&lang=js&"
export * from "./RightLowerBarLiteOpenProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856a8eca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('856a8eca')) {
      api.createRecord('856a8eca', component.options)
    } else {
      api.reload('856a8eca', component.options)
    }
    module.hot.accept("./RightLowerBarLiteOpenProject.vue?vue&type=template&id=856a8eca&scoped=true&", function () {
      api.rerender('856a8eca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LowerBar/LowerBarRightSide/Lite/RightLowerBarLiteOpenProject.vue"
export default component.exports